import React from 'react';
import { observer } from 'mobx-react';
import {
    Grid,
    Switch,
    Tooltip,
} from '@material-ui/core';

import Dialog from '../../../commons/dialog/Dialog';
import useEcalWorldSwitch from './useEcalWorldSwitch';

function EcalWorldSwitch (props) {
    const {
        isPublic,
        confirmOpen,
        tooltipTitle,
        dialogTitle,
        dialogText,
        handleToggle,
        handleConfirm,
        handleCancel,
        renderErrorDialog,
    } = useEcalWorldSwitch(props);

    return (
        <Grid>
            <Tooltip title={tooltipTitle}>
                <Switch
                    checked={isPublic}
                    onClick={handleToggle}
                    color="primary"
                    inputProps={{ 'aria-label': 'ECAL World public button' }}
                />
            </Tooltip>

            <Dialog
                openDialog={confirmOpen}
                buttonSecondary={'Cancel'}
                handleAgree={handleConfirm}
                closeModal={handleCancel}
                title={dialogTitle}
                dialogContextText={dialogText}
            />

            { renderErrorDialog() }
        </Grid>
    );
}

export default observer(EcalWorldSwitch);
